/**
 * Legal document version constants — hand-mirror of /legal_versions.py at repo root.
 * Source of truth is the Python file; keep these in sync manually until a
 * build-time auto-generation step is wired.
 *
 * Pointer: /legal_versions.py
 */
export const TERMS_VERSION = "2026-07-27";
export const PRIVACY_VERSION = "2026-07-27";
export const DPA_VERSION = "2026-07-27";
